import React from 'react'

const FormFile = ({
  id,
  name,
  className,
  placeholder,
  disabled,
  value,
  onChange,
  checked,
  readOnly,
  filename,
  icon,
  iconPos,
  size,
  accept,
}) => {
  return (
    <div
      className={
        'formfile' +
        (disabled ? ' formfile--disabled' : '') +
        (size ? ' formfile--' + size : ' formfile--md') +
        (className ? ' ' + className : '')
      }
    >
      <label className={`formfile__input-wrap`}>
        <input
          checked={checked}
          name={name}
          id={id}
          value={value}
          className="formfile__input"
          type="file"
          disabled={disabled}
          onChange={onChange}
          readOnly={readOnly}
          accept={accept}
        />
        <span className="formfile__content">
          {icon && iconPos === 'left' && <span className="formfile__icon">{icon}</span>}
          {filename ? (
            <span className="formfile__filename">{filename}</span>
          ) : (
            <span className="formfile__label">{placeholder ? placeholder : ''}</span>
          )}
          {icon && iconPos !== 'left' && <span className="formfile__icon">{icon}</span>}
        </span>
      </label>
    </div>
  )
}

export default FormFile
